<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }"
            >{{ $t("nav.home") }}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ $t("nav.quizz") }}
        </li>
      </ol>
    </nav>
    <b-row align-h="center" class="mb-2" cols="12">
      <b-col cols="6">
        <b-button v-b-modal.modal-quiz-add variant="success"
          ><font-awesome-icon :icon="['fas', 'plus']" />&nbsp;
          {{ $t("btn.add_quizz") }}
        </b-button>
        <b-modal
          id="modal-quiz-add"
          :title="$t('modal.title.add_quizz')"
          size="lg"
          scrollable
          hide-footer
        >
          <form-quiz
            @quizCreated="
              $root.$emit('bv::hide::modal', `modal-quiz-add`);
              getMiniQuizz();
            "
          />
        </b-modal>
        <b-modal
          id="modal-quiz-question"
          :title="$t('modal.title.edit_question')"
          size="lg"
          scrollable
          hide-footer
        >
          <form-question
            :question="questionToUpdate"
            @questionUpdated="
              $root.$emit('bv::hide::modal', `modal-quiz-question`);
              getMiniQuizz();
            "
          />
        </b-modal>
        <b-modal
          id="modal-quiz-edit"
          :title="$t('modal.title.edit_quizz')"
          size="lg"
          scrollable
          hide-footer
        >
          <form-quiz-simplified
            :quiz="quizToUpdate"
            @quizUpdated="
              $root.$emit('bv::hide::modal', `modal-quiz-edit`);
              getMiniQuizz();
            "
          />
        </b-modal>
      </b-col>
      <b-col cols="6">
        <b-button v-b-modal.modal-quiz-import variant="warning"
          ><font-awesome-icon :icon="['fas', 'file-import']" />&nbsp;
          {{ $t("btn.import_quizz") }}
        </b-button>
        <b-modal
          id="modal-quiz-import"
          :title="$t('modal.title.import_quizz')"
          scrollable
          hide-footer
        >
          <b-form>
            <b-form-file
              v-model="form.list"
              :state="Boolean(form.list)"
              :placeholder="$t('placeholder.import_quizz')"
              :drop-placeholder="$t('placeholder.drop.import_quizz')"
              accept=".zip"
            />
            <div v-if="form.list" class="m-3">
              {{$t('label.files_list')}} {{ form.list ? form.list.name : "" }}
            </div>
            <b-row class="text-right">
              <b-col>
                <b-button
                  :disabled="importPending"
                  class="m-2"
                  variant="success"
                  @click="
                    importQuiz();
                    importPending = true;
                  "
                >
                  <span v-if="importPending">
                    <b-spinner small variant="light" />
                  </span>
                  <span v-else> {{$t('btn.import')}} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card-group>
          <b-card
            :header="$t('label.list_quizz')"
            align="center"
            class="scrollable-card"
          >
            <b-card-text>
              <b-row>
                <b-col>
                  <b-row v-if="ifUpperEight">
                    <b-col>
                      <div class="alert-warning mt-3 mb-3 p-2">
                        {{ $t("alert.quiz.info") }}
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="m-0 p-0">
                      <b-form-group
                        :label="$t('label.filter')"
                        label-cols-sm="2"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            id="filterInput"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('placeholder.find_quiz')"
                          />
                          <b-input-group-append>
                            <b-button
                              :disabled="emptyFilter"
                              @click="cleanFilter()"
                              >{{ $t('btn.erase') }}
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-table
                        hover
                        :fields="fields"
                        :items="filteredItems"
                        :filter="filter"
                        :busy="loading"
                        small
                        responsive="sm"
                      >
                        <template #table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>{{ $t("btn.loading") }}</strong>
                          </div>
                        </template>
                        <template #cell(dmo_id)="row">
                          <b-col>{{ row.item.dmo_id }}</b-col>
                        </template>
                        <template #cell(quiz_name)="row">
                          <b-col>{{ row.item.dmo_data.title }}</b-col>
                        </template>
                        <template #cell(quiz_category)="row">
                          <b-col>
                            <b-row>
                              <b-col>
                                <b-badge
                                  :style="{
                                    'background-color':
                                      categories[row.item.dmo_data.category]
                                        .color,
                                  }"
                                >
                                  {{
                                    categories[row.item.dmo_data.category].label
                                  }}
                                </b-badge>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                <b-badge
                                  :variant="
                                    row.item.dmo_is_enable
                                      ? 'success'
                                      : 'warning'
                                  "
                                >
                                  {{
                                    row.item.dmo_is_enable ? $t('label.active') : $t('label.inactive')
                                  }}
                                </b-badge>
                              </b-col>
                            </b-row>
                          </b-col>
                        </template>
                        <template #cell(quiz_level)="row">
                          <b-col>
                            <b-badge
                              :style="{
                                'background-color':
                                  levelColor[row.item.dmo_data.level - 1],
                              }"
                            >
                              {{ levelLabel[row.item.dmo_data.level - 1] }}
                            </b-badge>
                          </b-col>
                        </template>
                        <template #cell(quiz_questions)="row">
                          <b-button
                            class="m-1"
                            variant="info"
                            @click="toggleDetails(row)"
                          >
                            <span v-if="row.detailsShowing" class="when-open"
                              ><font-awesome-icon
                                :icon="['fas', 'chevron-up']"
                              />&nbsp;</span
                            >
                            <span
                              v-if="!row.item._showDetails"
                              class="when-close"
                              ><font-awesome-icon
                                :icon="['fas', 'chevron-down']"
                              />&nbsp;</span
                            >
                            {{$t('label.list_questions')}}
                            </b-button
                          >
                        </template>
                        <template #row-details="row">
                          <b-card>
                            <b-row
                              v-for="question in row.item.questions"
                              :key="'question' + question.dmo_id"
                              class="form_questions"
                            >
                              <b-col>
                                <b-row>
                                  <b-col
                                    class="
                                      form_title
                                      mb-2
                                      text-left
                                      bg-light
                                      border-bottom
                                    "
                                    ><strong>
                                      {{ question.dmo_data.question }}
                                    </strong>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="4">
                                    <div
                                      v-if="
                                        icons.find(
                                          (e) =>
                                            e.key ===
                                            'question' + question.dmo_id
                                        )
                                      "
                                      :style="{
                                        backgroundImage: `url('data:image/png;base64,${
                                          icons.find(
                                            (e) =>
                                              e.key ===
                                              'question' + question.dmo_id
                                          ).img
                                        }'`,
                                      }"
                                      class="module-icon"
                                    />
                                  </b-col>
                                  <b-col cols="8">
                                    <b-row
                                      v-for="(answer, index) in question
                                        .dmo_data.answers"
                                      :key="'answer' + index + question.dmo_id"
                                    >
                                      <b-col>
                                        <b-badge
                                          :variant="
                                            answer.result
                                              ? 'success'
                                              : 'secondary'
                                          "
                                        >
                                          {{ answer.response }}
                                        </b-badge>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-row>
                                <b-row class="form_explanations">
                                  <b-col>
                                    {{ question.dmo_data.explanation.trim() }}
                                  </b-col>
                                </b-row>
                                <b-row class="text-right">
                                  <b-col class="text-right">
                                    <button
                                      type="button"
                                      role="button"
                                      class="btn"
                                      @click="editQuestion(question)"
                                    >
                                      <font-awesome-icon
                                        :icon="['fas', 'edit']"
                                      />
                                    </button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-card>
                        </template>
                        <template #cell(update)="row">
                          <b-row>
                            <b-col class="mt-1">
                              <b-button
                                size="sm"
                                variant="primary"
                                @click="editQuiz(row.item)"
                              >
                                <font-awesome-icon :icon="['fas', 'edit']" />
                                {{ $t("btn.update") }}
                              </b-button>
                            </b-col>
                            <b-col class="mt-1">
                              <b-button
                                v-b-modal="
                                  'modal-update-training-' + row.item.dmo_id
                                "
                                size="sm"
                                variant="warning"
                                @click="exportQuiz(row.item.dmo_id)"
                                >
                                <template v-if="IsDownload">
                                  <b-spinner small type="grow"></b-spinner>
                                  {{ $t("btn.loading") }}
                                </template>
                                <template v-else>
                                  <font-awesome-icon :icon="['fas', 'download']" />
                                  &nbsp;{{ $t("btn.export") }}
                                </template>
                              </b-button>
                            </b-col>
                            <b-col class="mt-1">
                              <b-button
                                :variant="
                                  row.item.dmo_is_enable ? 'dark' : 'success'
                                "
                                size="sm"
                                @click="changeQuizStatus(row.item)"
                                >
                                <font-awesome-icon v-if="row.item.dmo_is_enable" :icon="['fas', 'check-square']" />
                                <font-awesome-icon v-else :icon="['fas', 'square']" />
                                {{
                                  row.item.dmo_is_enable
                                    ? $t('btn.disable')
                                    : $t('btn.enable')
                                }}</b-button
                              >
                            </b-col>
                            <b-col class="mt-1">
                              <b-button
                                variant="danger"
                                size="sm"
                                @click="deleteQuiz(row.item)"
                                ><font-awesome-icon :icon="['fas', 'trash']" />
                                &nbsp;{{$t('btn.delete')}}
                                </b-button
                              >
                            </b-col>
                          </b-row>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormQuiz from "../components/forms/FormQuiz.vue";
import FormQuestion from "../components/forms/FormQuestion.vue";
import FormQuizSimplified from "../components/forms/FormQuizSimplified.vue";
// eslint-disable-next-line import/no-cycle
import { operationBus } from "../main";

export default {
  name: "MiniQuiz",
  components: { FormQuizSimplified, FormQuiz, FormQuestion },
  data() {
    return {
      title: "MiniQuiz",
      fields: [
        {
          dmo_id: {
            label: "Id",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          quiz_name: {
            label: "Nom",
            sortable: true,
            tdClass: "align-middle",
            filterByFormatted: true,
          },
        },
        {
          quiz_category: {
            label: "Catégorie",
            sortable: true,
            tdClass: "align-middle",
            filterByFormatted: true,
          },
        },
        {
          quiz_level: {
            label: "Difficulté",
            sortable: true,
            tdClass: "align-middle",
            filterByFormatted: true,
          },
        },
        {
          quiz_questions: {
            label: "Questions",
            sortable: true,
            tdClass: "align-middle",
            filterByFormatted: true,
            _showDetails: false,
          },
        },
        {
          update: {
            label: "Actions",
            sortable: false,
            tdClass: "align-middle",
          },
        },
      ],
      filter: "",
      loading: true,
      levelColor: ["#46A560", "#F8B605", "#F92300", "#470A00"],
      levelLabel: ["Facile", "Moyen", "Difficile", "Expert"],
      categories: {
        gastronomy: {
          label: "Gastronomie",
          color: "#ef7716",
          img: "gastronomy_icon.png",
        },
        sport: {
          label: "Sport et loisirs",
          color: "#d0dd72",
          img: "sport_icon.png",
        },
        entertainment: {
          label: "Divertissement",
          color: "#ea4b85",
          img: "entertainment_icon.png",
        },
        art: {
          label: "Arts et Culture",
          color: "#944794",
          img: "art_icon.png",
        },
        science: {
          label: "Sciences",
          color: "#60c5ed",
          img: "science_icon.png",
        },
        history: {
          label: "Histoire",
          color: "#64bc94",
          img: "history_icon.png",
        },
        geography: {
          label: "Géographie",
          color: "#6162a9",
          img: "geography_icon.png",
        },
      },
      changeType: null,
      formUpdate: null,
      questionToUpdate: null,
      quizToUpdate: null,
      IsDownload: false,
      icons: [],
      form: {
        list: null,
      },
      importPending: false,
      quizz: null,
    };
  },
  mounted() {
    this.getMiniQuizz();
  },
  computed: {
    ifUpperEight() {
      return this.quizz?.filter((e) => e.dmo_is_enable)?.length > 8;
    },
    emptyFilter() {
      return !this.filter || this.filter === "";
    },
    filteredItems() {
      return this.quizz?.filter((e) => !e.dmo_is_delete);
    },
  },
  methods: {
    toggleDetails(row) {
      row.toggleDetails();

      row.item.questions.forEach((q) => {
        this.getIcon(`question${q.dmo_id}`, q.ass_id);
      });
    },
    cleanFilter() {
      this.filter = "";
    },
    getIcon(id, dmoId) {
      this.$store.dispatch("modules/getBase64Image", dmoId).then((response) => {
        this.icons.push({ key: id, img: response.data });
      });
    },
    loadQuizz(quizz) {
      this.quizz = quizz;
      this.loading = false;
    },

    getMiniQuizz() {
      this.$store.dispatch("modules/getMiniQuizz", {}).then((response) => {
        if (response.data) this.loadQuizz(response.data);
      });
    },
    editQuiz(quiz) {
      this.quizToUpdate = quiz;
      this.$root.$emit("bv::show::modal", "modal-quiz-edit");
    },
    editQuestion(question) {
      this.questionToUpdate = question;
      this.$root.$emit("bv::show::modal", "modal-quiz-question");
    },
    changeQuizStatus(quiz) {
      const form = {
        dmo_id: quiz.dmo_id,
        quiz_id: quiz.dmo_data.id,
        dmo_is_enable: !quiz.dmo_is_enable,
        dmo_is_delete: quiz.dmo_is_delete,
      };
      this.$store
        .dispatch("modules/changeQuizStatus", form)
        .then(() => this.getMiniQuizz());
    },
    exportQuiz(dmoId) {
      this.IsDownload = true;
      this.$store.dispatch("modules/exportQuiz", { dmo_id: dmoId }).then(() => {
        this.IsDownload = false;
      });
    },
    importQuiz() {
      this.importPending = true;
      const formData = new FormData();
      formData.append("file", this.form.list);
      this.$store.dispatch("modules/importQuiz", formData).then(() => {
        this.getMiniQuizz();
        this.$root.$emit("bv::hide::modal", "modal-quiz-import");
        this.importPending = false;
      });
    },
    deleteQuiz(quiz) {
      const form = {
        dmo_id: quiz.dmo_id,
        quiz_id: quiz.dmo_data.id,
        dmo_is_enable: false,
        dmo_is_delete: true,
      };
      const operation = {
        id: `quiz${quiz.dmo_id}`, // TODO : Generate id
        cancel: false,
        action: `la suppression du quiz : ${quiz.dmo_data.title}`,
        request: "modules/changeQuizStatus",
        params: form,
      };
      operationBus.$emit("operationAdded", operation);
      operationBus.$on("operationFinished", () => {
        this.getMiniQuizz();
      });
    },
  },
};
</script>

<style scoped>
.form_questions {
  padding: 10px;
  background-color: aliceblue;
  border-radius: 10px;
  border: 1px solid rgb(0 123 255 / 50%);
  margin: 10px 0;
}
.form_explanations {
  padding: 10px;
  background-color: aliceblue;
  border-radius: 10px;
  border: 1px solid rgb(0 123 255 / 50%);
  margin: 10px 0;
  white-space: pre-line;
}
.form_explanations > .col {
  margin-top: -20px;
}
.form_title {
  font-size: 1em;
}
.module-icon {
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-origin: content-box;
  margin: auto;
  border-radius: 5px 5px 0 0;
  padding: 5px;
}
</style>
